import ContractTabs from "./ContractTabs";

export default ContractTabs;
